import { useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Work', path: '/work' },
    { name: 'Photography', path: '/photography' },
    { name: 'Fine Art', path: '/fine-art' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/90 backdrop-blur-sm z-50 border-b border-gray-100">
      <nav className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <a href="/" className="text-xl font-medium text-gray-900">
            <h1>Esteban's Stache</h1>
          </a>
          
          <div className="hidden md:flex items-center space-x-8">
            <a href="/work" className="text-gray-600 hover:text-gray-900 transition-colors">Professional Work</a>
            <a href="/fine-art" className="text-gray-600 hover:text-gray-900 transition-colors">Fine Art</a>
            <a href="/about" className="text-gray-600 hover:text-gray-900 transition-colors">About</a>
            <a href="/contact" className="text-gray-600 hover:text-gray-900 transition-colors">Contact</a>
          </div>
          
          <button 
            className="md:hidden w-6 h-6 flex items-center justify-center"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
        
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-100 pt-4">
            <div className="flex flex-col space-y-4">
              <a href="/work" className="text-gray-600 hover:text-gray-900 transition-colors">Professional Work</a>
              <a href="/fine-art" className="text-gray-600 hover:text-gray-900 transition-colors">Fine Art</a>
              <a href="/about" className="text-gray-600 hover:text-gray-900 transition-colors">About</a>
              <a href="/contact" className="text-gray-600 hover:text-gray-900 transition-colors">Contact</a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}